// Sidebar Width
export const SidebarWidth = 240;